const getPlayersCoordinate = (stageWidth: number, stageHeight: number) => {
  const playersCoordinates: [number, number][] = [
    [stageWidth * 0.2, stageHeight * 0.8],
    [0, 0],
    [0, 0],
    [stageWidth * 0.8, stageWidth * 0.2],
    [0, 0],
    [0, 0],
  ];
  return playersCoordinates;
};

const getPlayersAbsoluteCoordinate = (
  coordinateX: number,
  coordinateY: number
  // verticalPadding: number,
  // horizontalPadding: number
) => {
  const playersCoordinates: [number, number][] = [[coordinateX, coordinateY]];
  return playersCoordinates;
};

interface OneBezierProps {
  t: number;
  p1: [number, number];
  p2: [number, number];
}
/**
 *  one Tier Bezier Curve
 * @param {number} t time
 * @param {[number,number]} p1 start point
 * @param {[number,number]} p2 end point
 */
const oneBezier = ({t, p1, p2}: OneBezierProps) => {
  const [x1, y1] = p1;
  const [x2, y2] = p2;
  const x = x1 + t * (x2 - x1);
  const y = y1 + t * (y2 - y1);
  return [x, y];
};

interface TwoBezierProps {
  t: number;
  p1: [number, number];
  p2: [number, number];
  c1: [number, number];
}

/**
 *  two Tier Bezier Curve
 * @param {number} t time
 * @param {[number,number]} p1 start point
 * @param {[number,number]} p2 end point
 * @param {[number,number]} c1 control point
 */
const twoBezier = ({t, p1, p2, c1}: TwoBezierProps) => {
  // console.log('p1, p2, c1', p1, p2, c1);
  const [x1, y1] = p1;
  const [x2, y2] = p2;
  const [c1x, c1y] = c1;
  const x = (1 - t) * (1 - t) * x1 + 2 * t * (1 - t) * c1x + t * t * x2;
  const y = (1 - t) * (1 - t) * y1 + 2 * t * (1 - t) * c1y + t * t * y2;
  return [x, y];
};

const getControlPoint = ({
  senderPosition,
  receiverPosition,
  canvasHeight,
  canvasWidth,
}): [number, number] => {
  const xDiff = senderPosition[0] - receiverPosition[0];
  const yDiff = senderPosition[1] - receiverPosition[1];
  // console.log('xDiff, yDiff', xDiff, yDiff);
  const distance = Math.hypot(xDiff, yDiff);
  // console.log('distance, xDiff, yDiff', distance, xDiff, yDiff);
  const intensity = 0.5;
  const controlDistance = distance * intensity; // Adjust the intensity of the curve
  // const x = senderPosition.x + (xDiff / distance) * controlDistance;
  // const y = senderPosition.y + (yDiff / distance) * controlDistance;
  // console.log('controlPoint', x, y);
  if (xDiff <= canvasHeight / 2 && yDiff <= canvasWidth / 2) {
    // console.log(' &&& control point x is reduce &&&');
    return [canvasWidth * 0.5, canvasHeight * 0.8];
  }
  return [canvasWidth, canvasHeight];
};

// const getControlPoint = (startPoint, endPoint, intensity) => {
//   const dx = endPoint[0] - startPoint[0];
//   const dy = endPoint[1] - startPoint[1];
//   const distance = Math.sqrt(dx * dx + dy * dy);
//   console.log('startPoint, endPoint, intensity', startPoint, endPoint, intensity);
//   console.log('dx, dy, distance, ', dx, dy, distance);
//   const controlDistance = distance * intensity;

//   const controlPointX = startPoint[0] + (dx / distance) * controlDistance;
//   const controlPointY = startPoint[1] + (dy / distance) * controlDistance;
//   console.log('controlPointX, controlPointY', controlPointX, controlPointY);
//   return [controlPointX, controlPointY];
// };
// TODO perpendicular yes, but not the one close to center
const calculatePerpendicularPoint = (point1, point2, canvas, offset) => {
  const midX = (point1.x + point2.x) / 2;
  const midY = (point1.y + point2.y) / 2;

  const dx = point2.x - point1.x;
  const dy = point2.y - point1.y;

  const perpPoint1 = {x: midX - dy * offset, y: midY + dx * offset};

  // Second perpendicular point
  const perpPoint2 = {x: midX + dy * offset, y: midY - dx * offset};

  const stageCenter = {x: canvas.width / 2, y: canvas.height / 2};

  const calculateDistance = (point1, point2) => {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const distanceToCenter1 = calculateDistance(perpPoint1, stageCenter);
  const distanceToCenter2 = calculateDistance(perpPoint2, stageCenter);

  const closerPoint = distanceToCenter1 < distanceToCenter2 ? perpPoint1 : perpPoint2;

  // console.log('Perpendicular Point 1:', perpPoint1.x, perpPoint1.y);
  // console.log('Perpendicular Point 2:', perpPoint2.x, perpPoint2.y);
  // console.log('Point Closer to Center:', closerPoint.x, closerPoint.y);
  return closerPoint;
};

// const calculateDistance = (point1, point2): number => {
//   const dx = point2.x - point1.x;
//   const dy = point2.y - point1.y;
//   return Math.sqrt(dx * dx + dy * dy);
// };

// const calculatePerpendicularPoint = (point1, point2, canvas) => {
//   const centerX = canvas.width / 2;
//   const centerY = canvas.height / 2;

//   const distanceToCenter1 = calculateDistance(point1, { x: centerX, y: centerY });
//   const distanceToCenter2 = calculateDistance(point2, { x: centerX, y: centerY });

//   return distanceToCenter1 < distanceToCenter2 ? point1 : point2;

// };
interface ThreeBezierProps {
  t: number;
  p1: [number, number];
  p2: [number, number];
  c1: [number, number];
  c2: [number, number];
}
/**
 *  three Tier Bezier Curve
 * @param {number} t time
 * @param {[number,number]} p1 start point
 * @param {[number,number]} p2 end point
 * @param {[number,number]} c1 control point
 * @param {[number,number]} c2 control point
 */
const threeBezier = ({t, p1, p2, c1, c2}: ThreeBezierProps) => {
  const [x1, y1] = p1;
  const [x2, y2] = p2;
  const [c1x, c1y] = c1;
  const [c2x, c2y] = c2;
  const x =
    (1 - t) * (1 - t) * (1 - t) * x1 +
    3 * t * (1 - t) * (1 - t) * c1x +
    3 * t * t * (1 - t) * c2x +
    t * t * t * x2;
  const y =
    (1 - t) * (1 - t) * (1 - t) * y1 +
    3 * t * (1 - t) * (1 - t) * c1y +
    3 * t * t * (1 - t) * c2y +
    t * t * t * y2;
  return [x, y];
};

export {
  getPlayersCoordinate,
  getPlayersAbsoluteCoordinate,
  getControlPoint,
  calculatePerpendicularPoint,
  oneBezier,
  twoBezier,
  threeBezier,
};
